import ProfileButton from "./ProfileButton";
import GiftIcon from "../Icons/GiftIcon";
import { getChildIdParam } from "../../helpers/helpers";

export function GiveGiftButton(props) {
  const childId = getChildIdParam();

  return (
    <ProfileButton 
      classList="profile-button__gift"
      requires={["commitment"]}
      ctaUrl={`/giving-center?ID=${childId}`}
      icon={<GiftIcon />}
      {...props}
    >
       Give a gift
    </ProfileButton>
  );
}

export default GiveGiftButton;